import {
  dateFormat,
  useGetTimeSlotsSpecific,
} from "@/api/AppApi/services/time-slots";
import moment from "moment/moment";
import { useEffect, useState } from "react";
import { Collapse } from "@/utils/bootstrap";
import AppointmentTypesDropdown from "./day-appointments-box-helpers/AppointmentTypesDropdown";
import SvgCloseAppointment from "./day-appointments-box-helpers/day-appointments/day-appointments-helpers/day-appointments-icons/SvgCloseAppointment";
import DayAppointments from "./day-appointments-box-helpers/day-appointments/DayAppointments";
import GeneralApiLoader from "@/app/components/lib/loaders/GeneralApiLoader";
import { FieldValues, UseFormReturn } from "react-hook-form";
import { ICommonProductDetails } from "@/api/AppApi/services/product/interfaces/api-product-details-interface";
import { IuseProductHasAttrsResult } from "@/hooks/product-has-attrs/product-has-attrs-helpers/interfaces";
interface Props {
  product: ICommonProductDetails;
  date: moment.Moment | null;
  onClose: () => void;
  beside: boolean;
  show: boolean;
  form: UseFormReturn<FieldValues, any>;
  productState?: IuseProductHasAttrsResult;
}
const DayAppointmentsBox: React.FC<Props> = ({
  product,
  onClose,
  beside,
  show,
  date,
  form,
  productState,
}) => {
  const getTimeSlotsSpecific = useGetTimeSlotsSpecific({
    product_id: productState?.currentProd?.id || product?.id,
    date: date ? moment(date)?.locale("en").format(dateFormat) : null,
    time: moment().locale("en").format("HH:mm"),
  });
  const timeSlotsSpecific = getTimeSlotsSpecific?.data?.result ?? [];
  const dateString = date
    ? date
        ?.locale(moment.locale())
        .format(moment.locale() === "ar" ? "dddd " : "ddd ") +
      date?.locale("en").format("DD") +
      date?.locale(moment.locale()).format(" MMMM ") +
      date?.locale("en").format("y")
    : "";

  const [selectedServiceId, setSelectedServiceId] = useState<number | null>(
    null,
  );

  useEffect(() => {
    if (getTimeSlotsSpecific.isFetching) return;
    (!selectedServiceId || !!product) &&
      setSelectedServiceId(timeSlotsSpecific?.[0]?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getTimeSlotsSpecific.isFetching, product, date]);
  return (
    <Collapse in={show} dimension={beside ? "width" : "height"}>
      <div>
        <div
          className={`${
            beside ? "appointments-beside" : "appointments-inside"
          }`}
        >
          {getTimeSlotsSpecific.isLoading ? (
            <GeneralApiLoader primary={!beside} primaryReverse={beside} />
          ) : (
            <>
              <div className="calendar-appointment-header">
                {dateString}
                <SvgCloseAppointment grid={beside} onClick={onClose} />
              </div>
              {!product && (
                <AppointmentTypesDropdown
                  services={timeSlotsSpecific}
                  selectedServiceId={selectedServiceId}
                  setSelectedServiceId={setSelectedServiceId}
                />
              )}
              <DayAppointments
                form={form}
                product={product}
                beside={beside}
                productState={productState}
                slotsDetails={timeSlotsSpecific?.find(
                  (slot) => slot.id === selectedServiceId,
                )}
              />
            </>
          )}
        </div>
      </div>
    </Collapse>
  );
};

export default DayAppointmentsBox;
